// extracted by mini-css-extract-plugin
export default {"whatsapp":"FloatingWhatsApp_whatsapp__UMeJ2"};